import { useRef, useState } from "react";
import { cn } from "../../design-system/tokens";
import { useLangStore } from "../../store/langStore";
import { t as tr } from "../../lib/i18n";
interface Props { onFiles:(files:File[])=>void; label?:string; accept?:string; }
export function ReferenceDropzone({ onFiles, label="Arrastra archivos Excel/CSV y/o SCL (.scd/.cid)", accept=".xlsx,.xls,.csv,.txt,.scd,.cid,.icd,.iid,.scl,.xml" }: Props) {
  const { lang } = useLangStore();
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  return (
    <div onDragOver={(e)=>{e.preventDefault();setOver(true);}} onDragLeave={()=>setOver(false)}
      onDrop={(e)=>{e.preventDefault();setOver(false);onFiles([...e.dataTransfer.files]);}}
      onClick={()=>inputRef.current?.click()}
      className={cn("flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-8 text-center transition-colors",
        over ? "border-[var(--color-brand)] bg-[var(--color-brand-soft-10)]"
             : "border-[var(--color-border)] hover:border-[var(--color-brand-border-60)]")}>
      <input ref={inputRef} type="file" multiple accept={accept} className="hidden"
        onChange={(e)=>{ if(e.target.files) onFiles([...e.target.files]); }} />
      <p className="text-sm font-medium">{tr(label,lang)}</p>
      <p className="text-xs text-[var(--color-on-surface-variant)]">{tr("Procesamiento local en el navegador. Nada se sube a un servidor.",lang)}</p>
    </div>
  );
}
